import { backofficeLoginRouter } from '../modules/auth/router'
import { backofficeHomeRouter } from '../modules/home/router'
import { useFirebase } from '@/firebase/useFirebase'
import type {
  RouteLocationNormalized,
  NavigationGuardNext
} from 'vue-router';
const { currentAuthUser } = useFirebase()
const backofficeRouter = {
  path: '/backoffice',
  name: 'backoffice',
  component: () => import('../views/Backoffice.vue'),
  meta: {
    requiresAuth: true
  },
  children: [backofficeLoginRouter, backofficeHomeRouter],
  beforeEnter: (to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext) => {
    const requiresAuth = to.meta.requiresAuth || false
    if (requiresAuth && !currentAuthUser.value) next('/backoffice/login')
    else if (!requiresAuth && currentAuthUser.value) next('/backoffice')
    else next()
  }
}

export { backofficeRouter }
